import JWT from "jsonwebtoken";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export function generateReaderToken(
  publication,
  apiKey,
  extraParams = {},
  algorithm = "HS256",
  pwd = "616161"
) {
  apiKey = apiKey || process.env.REACT_APP_API_SECRETE;
  const subKioskId = cookies.get("smartPress");

  let userData = {
    apiKey: apiKey,
    api_key: apiKey,
    kiosk: process.env.REACT_APP_API_SECRETE,
    subKioskId,

    ...extraParams
  };

  let oHeader = { algorithm };
  let oPayload = {
    publication,
    userData,
    apiUrl: "https:/prod.kioskp.com/api",
    subKioskId,
    ...extraParams
  };

  console.warn(oPayload);
  
  return JWT.sign(oPayload, pwd, oHeader);
}

export function getPublicationReaderUrl(
  publication,
  apiKey,
  readerUrl,
  extraParams = {}
) {
  const jwt = generateReaderToken(publication, apiKey, extraParams);

  return readerUrl + jwt;
}

const PublicationHelper = {
  generateReaderToken,
  getPublicationReaderUrl
};
export default PublicationHelper;



// WEBPACK FOOTER //
// ./src/helpers/Publication.js